import { IntegrationKey } from 'entities/Integrations'
import { AddNumberFromAppRoutes } from 'pages/settings/pages/numbers/pages/AddNumberFromApp/route/type'

export type AddNumberFromAppStepsRoutes =
  | AddNumberFromAppRoutes.selectAppAndNumbers
  | AddNumberFromAppRoutes.assignNumber
export const titleMap: Record<string, string> = {
  [AddNumberFromAppRoutes.selectAppAndNumbers]: 'Select app & numbers',
  [AddNumberFromAppRoutes.assignNumber]: 'Assign number',
}

export const availableIntegrationToAddNumber = [IntegrationKey.aircall] as const
export type AvailableIntegrationKey = (typeof availableIntegrationToAddNumber)[number]
